import { GetSpaceBase } from '../../types/GetSpaceBase';
import { getUndefinedSpace } from '../../utils/getUndefinedSpace';

export const getSpaceRappiPrestamo: GetSpaceBase = () => {
  return getUndefinedSpace();
};
